import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { ConsultantActionType, ConsultantStoreElement, ImmutableCompetitionProperty } from './ConsultantReducer.types';

// @ts-ignore
const initialState: ConsultantStoreElement = Immutable.fromJS({
  isFetching: false,
  failure: false,
  data: Immutable.Map<string, ImmutableCompetitionProperty>(),
});

const ConsultantReducer = handleActions(
  {
    AUTHENTICATION_LOGOUT: () => initialState,
    REQUEST_CONSULTANT: (state: ConsultantStoreElement) => state.set('isFetching', true),
    RESPONSE_CONSULTANT_FAILURE: (state: ConsultantStoreElement) => state.set('isFetching', false).set('failure', true),
    RESPONSE_CONSULTANT_SUCCESS: (state: ConsultantStoreElement, action: ConsultantActionType) =>
      state.set('isFetching', false).set('failure', false).set('data', Immutable.fromJS(action.payload.data)),
  },
  initialState
);

export default ConsultantReducer;
